import { restClient } from '../client';

export type InitiateContactVerificationErrorOutput = {
  error: string;
};

export type InitiateContactVerificationOutput = {
  status?: string;
};

export const initiateContactVerification = (contactId: string) => {
  return restClient.request<InitiateContactVerificationOutput>(
    `/api/v1/contacts/${contactId}/initiate_verification`,
    {
      method: 'POST',
    }
  );
};


export type VerifyContactInput = {
  verification_code: string;
};

export type VerifyContactOutput = Record<string, never>;

export type VerifyContactErrorOutput = {
  error: 'Invalid OTP' | 'Contact already verified';
};

export const verifyContact = (contactId: string, { verification_code }: VerifyContactInput) => {
  return restClient.request<VerifyContactOutput>(
    `/api/v1/contacts/${contactId}/verify`,
    {
      method: 'POST',
      data: {
        verification_code,
      },
    }
  );
};
